import * as React from 'react';
import { PartialRouteObject } from 'react-router';
import { useRoutes } from 'react-router-dom';
import { useMiaSelector } from '../components/hooks';
import { Unauthorized } from '../components/Unauthorized';
import { AccessLevel, getPermissions, PermissionTypes } from '../ducks/auth';
import { routes } from './layoutConstants';

interface IMainContentProps {}

let MainContent: React.ComponentType<IMainContentProps> = ({}) => {
  const permissions = useMiaSelector(getPermissions);

  const authedRoutes = React.useMemo(() => {
    const hasPermissions = (routePerms: PermissionTypes[] = []): boolean => {
      if (routePerms.length === 0) {
        return true;
      }

      // create an array of the requested access levels
      const perms = routePerms.map<AccessLevel>(x => (permissions[x] ? permissions[x].accessLevel : AccessLevel.None));

      // check if some of them are not equal to none
      return perms.some(x => x !== AccessLevel.None);
    };

    return Object.values(routes).map<PartialRouteObject>(x => ({
      ...x,
      children: x.children?.map(y => ({
        ...y,
        element: hasPermissions(y.permissionTypes) ? y.element : <Unauthorized />
      })),
      element: hasPermissions(x.permissionTypes) ? x.element : <Unauthorized />
    }));
  }, [permissions]);

  const elements = useRoutes(authedRoutes);

  return elements;
};

MainContent = React.memo(MainContent);
export { MainContent };
